import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, profile, countries} from "config/config"; // Importing configuration settings

/**
 * Class representing the FilterCurrencyTRMView.
 * @extends JetView
 */
export default class FilterCurrencyTRMView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config(){
        const _ = this.app.getService("locale")._; // Localization service for translations
        const left = {
            margin: 5,
            id:"a1", // Unique identifier for the left section
            rows: [] // Placeholder for rows in the left section
        };
        const upper_section = {
            css: "father-container", // CSS class for styling
            rows:[{
                margin: 10,
                cols: [
                    left // Adding the left section to the upper section
                ]
            }]
        };
        const buttons = {
            id:"b2", // Unique identifier for the button section
            rows:[
                {
                    margin:10,
                    responsive: "b2", // Responsive design identifier
                    cols:[
                        {id: "grav2", gravity: 3}, // Column with gravity for layout
                        {
                            view:"button", value:_("Crear TRM"), type:"form", width: (screen == "small") ? 0 : 0, minWidth: 200,
                            click:()=> { // Click event for creating TRM
                                this.app.callEvent("exchangeRateTRM:button",[{}])
                            }
                        },
                        {
                            view:"button", value:_("TRM Criptomoneda"), type:"form", width: (screen == "small") ? 0 : 0, minWidth: 200,
                            hidden: !devConfig.getPermAction("CryptoTrmCreateEdit", "Add"),
                            click:()=> { // Click event for creating TRM
                                this.app.callEvent("exchangeRateTRMCrypto:button",[{}])
                            }
                        },
                        {
                            view:"button", value: _("Consultar"), hotkey:"enter", type:"form", width: (screen == "small") ? 0 : 0,  minWidth: 200, id: "consultDesk",
                            click:() => { // Click event for consulting
                                var filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getPartnerSelected()){ // Check if a partner is selected
                                    filterdata.Partner = profile.PartnerSelected // Set partner in filter data
                                }
                                this.app.callEvent("currencyTRM:filter",[filterdata]); // Trigger filter event
                                $$("b5").collapse(); // Collapse the section
                            }
                        }
                    ]
                }
            ]
        };
        const accordion_section2 = {
            type:"wide", // Type of the accordion section
            rows: [
                {
                    header: _(""), id: "b5", body: {
                        padding:10,
                        rows: [buttons] // Adding buttons to the accordion body
                    }
                }
            ]
        }
        return {
            view:"form", // Main view type
            type: "clean", // Clean form type
            rows:[
                (screen.width > 500  && screen.height > 500) ? accordion_section2 : {height:1,width:0} // Conditional rendering based on screen size
            ],
            rules:{
                "fname":webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }

    /**
     * Initializes the view and fetches currency data.
     */
    init() {
        webix.ready(function () { // Ensures Webix is ready
        });
        webix.ajax().headers({
            "Content-type": "application/json" // Setting content type for the AJAX request
        }).post(devConfig.geturlApi() + "TRM/GetCurrenciesTrm", {global : true} , {
            error: function () { // Error handling for AJAX request
                webix.message("Error!") // Display error message
            },
            success: function (text){ // Success handling for AJAX request
                let resp = JSON.parse(text) // Parse the response text
                for (let i = 0; i < resp.data.length; i++){ // Loop through the response data
                    resp.data[i].id = resp.data[i].Id; // Map Id to id
                    resp.data[i].value = resp.data[i].baseCurrency; // Map baseCurrency to value
                }
                // Define options for various currency dropdowns and refresh them
                if ($$("AddSourceCurrency")) {
                    $$("AddSourceCurrency").define("options", resp.data);
                    $$("AddSourceCurrency").refresh();
                }
                if ($$("AddDestinationCurrency")) {
                    $$("AddDestinationCurrency").define("options", resp.data);
                    $$("AddDestinationCurrency").refresh();
                }
                if ($$("EditDestinationCurrency")) {
                    $$("EditDestinationCurrency").define("options", resp.data);
                    $$("EditDestinationCurrency").refresh();
                }
                if ($$("Currency")) {
                    $$("Currency").define("options", resp.data);
                    $$("Currency").refresh();
                }
                if ($$("AddSourceCrypto")) {
                    $$("AddSourceCrypto").define("options", resp.data);
                    $$("AddSourceCrypto").refresh();
                }
            }
        });

        // --- CRYPTO ---
        webix.ajax().headers({
            "Content-type": "application/json"
        }).post(devConfig.geturlApi() + "TRM/GetCryptoTrm", { global: true }, {
            error: function () {
                webix.message("Error al cargar monedas Crypto!");
            },
            success: function (text) {
                let resp = JSON.parse(text);

                resp.data.forEach(d => {
                    d.id = d.Id;
                    d.value = d.baseCurrency;
                });

                if ($$("AddDestinationCrypto")) {
                    $$("AddDestinationCrypto").define("options", resp.data);
                    $$("AddDestinationCrypto").refresh();
                }
            }
        });
    }

}

// FILE DOCUMENTED
